<template>

<template
    v-if="isAccessChecked && isAdmin"
  >

<PipelineVacancyDraftsOverlay
  :show="showPipelineOverlay"
  :status="pipelineOverlayStatus"
  :result="pipelineResult"
  :error-message="pipelineErrorMessage"
  @close="closePipelineOverlay"
/>

<Transition name="publish-popup">

<div
  v-if="showPublishPopup"
  class="publish-popup"
>

  <div class="publish-popup-icon">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 12.5L10 17L19 7"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="publish-popup-content">

    <strong>
      Вакансия отправлена
    </strong>

    <span>
      {{ publishPopupMessage }}
    </span>

  </div>

</div>

</Transition>

    <div
      class="admin-vacancy-drafts"
      :class="themeClass"
    >
  
      <!-- ======================================================
           HEADER
      ======================================================= -->
  
      <div class="page-header">
  
        <div>
  
          <p class="page-eyebrow">
            ADMIN / VACANCY PIPELINE
          </p>
  
          <h1 class="page-title">
            Черновики вакансий
          </h1>
  
          <p class="page-description">
            Вакансии, подготовленные автоматическим пайплайном.
          </p>
  
        </div>
  
        <div class="page-header-actions">

          <button
            class="pipeline-button"
            :disabled="
              isPipelineRunning
              || isLoading
            "
            @click="runVacancyPipeline"
          >

            <span class="pipeline-button-icon">

              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <circle
                  cx="6"
                  cy="6"
                  r="2.5"
                  stroke="currentColor"
                  stroke-width="1.8"
                />

                <circle
                  cx="18"
                  cy="12"
                  r="2.5"
                  stroke="currentColor"
                  stroke-width="1.8"
                />

                <circle
                  cx="6"
                  cy="18"
                  r="2.5"
                  stroke="currentColor"
                  stroke-width="1.8"
                />

                <path
                  d="M8.5 6H11C14.8 6 14.4 12 18 12"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />

                <path
                  d="M8.5 18H11C14.8 18 14.4 12 18 12"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>

            </span>

            <span>
              {{
                isPipelineRunning
                  ? "Пайплайн работает"
                  : "Запустить пайплайн"
              }}
            </span>

          </button>


          <button
            class="refresh-button"
            :disabled="
              isLoading
              || isPipelineRunning
            "
            @click="loadDrafts"
          >

            <span
              class="refresh-icon"
              :class="{
                rotating: isLoading
              }"
            >
              ↻
            </span>

            Обновить

          </button>

          </div>
  
      </div>
  
      <!-- ======================================================
           STATS
      ======================================================= -->
  
      <div class="stats-grid">
  
        <button
          class="stat-card"
          :class="{
            active:
              activeFilter === 'all'
          }"
          @click="
            activeFilter = 'all'
          "
        >
  
          <span class="stat-label">
            Всего
          </span>
  
          <strong class="stat-value">
            {{ counts.total }}
          </strong>
  
        </button>
  
  
        <button
          class="stat-card"
          :class="{
            active:
              activeFilter === 'ready'
          }"
          @click="
            activeFilter = 'ready'
          "
        >
  
          <span class="stat-label">
            Готовы
          </span>
  
          <strong class="stat-value success">
            {{ counts.ready }}
          </strong>
  
        </button>
  
  
        <button
          class="stat-card"
          :class="{
            active:
              activeFilter === 'company_problem'
          }"
          @click="
            activeFilter =
              'company_problem'
          "
        >
  
          <span class="stat-label">
            Проблемы компаний
          </span>
  
          <strong class="stat-value warning">
            {{ companyProblemsCount }}
          </strong>
  
        </button>
  
  
        <button
          class="stat-card"
          :class="{
            active:
              activeFilter === 'image_problem'
          }"
          @click="
            activeFilter =
              'image_problem'
          "
        >
  
          <span class="stat-label">
            Нет изображения
          </span>
  
          <strong class="stat-value warning">
            {{ imageProblemsCount }}
          </strong>
  
        </button>
  
      </div>
  
      <!-- ======================================================
           TOOLBAR
      ======================================================= -->
  
      <div class="toolbar">
  
        <div class="search-wrapper">
  
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle
              cx="11"
              cy="11"
              r="6"
              stroke="currentColor"
              stroke-width="1.7"
            />
  
            <path
              d="m16 16 4 4"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
  
          <input
            v-model="searchQuery"
            type="text"
            placeholder="Название вакансии или компании"
            class="search-input"
          />
  
        </div>
  
        <div class="filter-tabs">
  
          <button
            v-for="filter in filters"
            :key="filter.value"
            class="filter-tab"
            :class="{
              active:
                activeFilter
                === filter.value
            }"
            @click="
              activeFilter =
                filter.value
            "
          >
            {{ filter.title }}
          </button>
  
        </div>
  
      </div>
  
      <!-- ======================================================
           LOADING
      ======================================================= -->
  
      <div
        v-if="isLoading"
        class="loading-list"
      >
  
        <div
          v-for="index in 5"
          :key="index"
          class="draft-skeleton"
        >
          <div class="skeleton-image"></div>
  
          <div class="skeleton-content">
  
            <div class="skeleton-line small"></div>
  
            <div class="skeleton-line title"></div>
  
            <div class="skeleton-line"></div>
  
            <div class="skeleton-line short"></div>
  
          </div>
        </div>
  
      </div>
  
      <!-- ======================================================
           ERROR
      ======================================================= -->
  
      <div
        v-else-if="errorMessage"
        class="state-card error-state"
      >
  
        <div class="state-icon">
          !
        </div>
  
        <h3>
          Не удалось загрузить черновики
        </h3>
  
        <p>
          {{ errorMessage }}
        </p>
  
        <button
          class="state-button"
          @click="loadDrafts"
        >
          Повторить
        </button>
  
      </div>
  
      <!-- ======================================================
           EMPTY
      ======================================================= -->
  
      <div
        v-else-if="
          filteredDrafts.length === 0
        "
        class="state-card"
      >
  
        <div class="state-icon">
          ∅
        </div>
  
        <h3>
          Ничего не найдено
        </h3>
  
        <p>
          Попробуй изменить фильтр
          или поисковый запрос.
        </p>
  
      </div>
  
      <!-- ======================================================
           DRAFTS
      ======================================================= -->
  
      <template v-else>
  
        <div class="results-row">
  
          <span>
            Найдено:
            <strong>
              {{ filteredDrafts.length }}
            </strong>
          </span>
  
        </div>
  
        <div class="draft-list">


          <VacancyDraftComponent
            v-for="draft in filteredDrafts"
            :key="draft.id"
            :draft="draft"
            @create-company="openCreateCompanyDrawer"
            @add-images="openCompanyImages"
            @publish="publishDraft"
            @delete-draft="deleteDraft"
            @update-description="updateDraftDescription"
            @update-title="updateDraftTitle"
          />
  
        </div>
  
      </template>
  
    </div>


    <CreateCompanyAdminDrawer
      v-if="showCompanyDrawer"
      @close="closeCreateCompanyDrawer"
      @success="handleCompanyCreated"
    />

   </template>
  
  </template>
  
  <script setup>


import {
  waitForAuthReady
} from "../utils/auth.js";

import {
  useRouter
} from "vue-router";
  
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref
} from "vue";
  
  import AdminService
    from "../api/AdminService";
  
  import VacancyDraftComponent
    from "../components/VacancyDraftComponent.vue";
  
  import CreateCompanyAdminDrawer
    from "../views/CreateCompanyAdminDrawer.vue";

  import PipelineVacancyDraftsOverlay
    from "../components/PipelineVacancyDraftsOverlay.vue";
  
    const publishingDraftId =
      ref(null);

   const deletingDraftId = ref(null);

    const publishPopupMessage =
      ref("");

    const showPublishPopup =
      ref(false);

    let publishPopupTimer =
      null;

  const drafts =
    ref([]);
  
  const counts =
    ref({
      total:
        0,
  
      ready:
        0,
  
      company: {
        pending:
          0,
  
        resolved:
          0,
  
        notFound:
          0,
  
        ambiguous:
          0,
  
        failed:
          0
      },
  
      image: {
        pending:
          0,
  
        resolved:
          0,
  
        notFound:
          0,
  
        failed:
          0
      }
    });

    const isAccessChecked =
      ref(false);

    const isAdmin =
      ref(false);
  

  const isPipelineRunning =
    ref(false);

  const showPipelineOverlay =
    ref(false);

  const pipelineOverlayStatus =
    ref("idle");

  const pipelineResult =
    ref(null);

  const pipelineErrorMessage =
    ref("");

  const router = useRouter();
  
  const isLoading =
    ref(false);
  
  const errorMessage =
    ref("");
  
  const searchQuery =
    ref("");
  
  const activeFilter =
    ref("all");
  
  const themeClass =
    ref(
      getCurrentThemeClass()
    );

  const showCompanyDrawer =
    ref(false);

  const selectedDraftForCompany =
    ref(null);
  
  
  let themeObserver =
    null;
  
  
  const filters = [
    {
      value:
        "all",
  
      title:
        "Все"
    },
  
    {
      value:
        "ready",
  
      title:
        "Готовы"
    },
  
    {
      value:
        "company_problem",
  
      title:
        "Компании"
    },
  
    {
      value:
        "image_problem",
  
      title:
        "Изображения"
    },
  
    {
      value:
        "pending",
  
      title:
        "Ожидают"
    }
  ];

  function openCompanyImages(
  draft
) {

  const companyId =
    draft.companyId;

  if (!companyId) {

    console.warn(
      "⚠️ Нельзя открыть изображения: companyId отсутствует",
      draft
    );

    return;
  }

  router.push(
    `/admin-edit-company/${companyId}`
  );

}
  
  
  const companyProblemsCount =
    computed(
      () =>
        (
          counts.value
            .company
            .notFound
          ?? 0
        )
        +
        (
          counts.value
            .company
            .ambiguous
          ?? 0
        )
        +
        (
          counts.value
            .company
            .failed
          ?? 0
        )
    );
  
  
  const imageProblemsCount =
    computed(
      () =>
        (
          counts.value
            .image
            .notFound
          ?? 0
        )
        +
        (
          counts.value
            .image
            .failed
          ?? 0
        )
    );
  
  
  const filteredDrafts =
    computed(
      () => {
  
        const query =
          searchQuery.value
            .trim()
            .toLocaleLowerCase(
              "ru"
            );
  
        return drafts.value.filter(
          draft => {
  
            // ================================================
            // SEARCH
            // ================================================
  
            if (query) {
  
              const haystack = [
                draft.title,
                draft.companyName,
                draft.sourceProvider,
                draft.city,
                draft.externalId
              ]
                .filter(
                  Boolean
                )
                .join(
                  " "
                )
                .toLocaleLowerCase(
                  "ru"
                );
  
              if (
                !haystack.includes(
                  query
                )
              ) {
  
                return false;
  
              }
  
            }
  
            // ================================================
            // FILTER
            // ================================================
  
            switch (
              activeFilter.value
            ) {
  
              case "ready":
  
                return (
                  draft.isReady
                );
  
  
              case "company_problem":
  
                return (
                  draft.isCompanyNotFound
                  || draft.isCompanyAmbiguous
                  || draft.isCompanyFailed
                );
  
  
              case "image_problem":
  
                return (
                  draft.isCompanyResolved
                  &&
                  (
                    draft.isImageNotFound
                    || draft.isImageFailed
                  )
                );
  
  
              case "pending":
  
                return (
                  draft.companyResolutionStatus
                    === "pending"
                  ||
                  (
                    draft.isCompanyResolved
                    &&
                    draft.imageResolutionStatus
                      === "pending"
                  )
                );
  
  
              default:
  
                return true;
  
            }
  
          }
        );
  
      }
    );
  
    async function loadDrafts() {
  if (isLoading.value) {
    return;
  }

  isLoading.value = true;
  errorMessage.value = "";

  try {
    const result = await AdminService
      .getAdminVacancyDrafts();

    drafts.value =
      result.vacancyDrafts ?? [];

    recalculateCounts();

    console.log(
      "✅ Vacancy drafts loaded:",
      drafts.value.length
    );
  } catch (error) {
    console.error(
      "❌ loadDrafts error:",
      error
    );

    errorMessage.value =
      error?.response?.data?.error
      || error?.message
      || "Неизвестная ошибка";
  } finally {
    isLoading.value = false;
  }
}

function recalculateCounts() {

const items =
  drafts.value;

counts.value = {

  total:
    items.length,

  ready:
    items.filter(
      draft =>
        draft.isReady
    ).length,

  company: {

    pending:
      items.filter(
        draft =>
          draft.companyResolutionStatus
            === "pending"
      ).length,

    resolved:
      items.filter(
        draft =>
          draft.companyResolutionStatus
            === "resolved"
      ).length,

    notFound:
      items.filter(
        draft =>
          draft.companyResolutionStatus
            === "not_found"
      ).length,

    ambiguous:
      items.filter(
        draft =>
          draft.companyResolutionStatus
            === "ambiguous"
      ).length,

    failed:
      items.filter(
        draft =>
          draft.companyResolutionStatus
            === "failed"
      ).length
  },

  image: {

    pending:
      items.filter(
        draft =>
          draft.imageResolutionStatus
            === "pending"
      ).length,

    resolved:
      items.filter(
        draft =>
          draft.imageResolutionStatus
            === "resolved"
      ).length,

    notFound:
      items.filter(
        draft =>
          draft.imageResolutionStatus
            === "not_found"
      ).length,

    failed:
      items.filter(
        draft =>
          draft.imageResolutionStatus
            === "failed"
      ).length
  }
};

}

async function updateDraftTitle({
  draft,
  title
}) {
  if (!draft?.id) {
    console.error(
      "❌ У VacancyDraft отсутствует id",
      draft
    );

    return;
  }

  const normalizedTitle =
    String(title || "").trim();

  if (!normalizedTitle) {
    window.alert(
      "Название вакансии не может быть пустым"
    );

    return;
  }

  try {
    console.log(
      "📝 Обновляем title VacancyDraft:",
      draft.id
    );

    const result =
      await AdminService
        .updateAdminVacancyDraftTitle(
          draft.id,
          normalizedTitle
        );

    console.log(
      "✅ Title VacancyDraft обновлён:",
      result
    );

    // Не мутируем VacancyDraft напрямую.
    // Перечитываем свежую модель с backend.
    await loadDrafts();

  } catch (error) {
    console.error(
      "❌ Ошибка обновления title VacancyDraft:",
      error.response?.data
      || error.message
    );

    const message =
      error?.response?.data?.error
      || error?.message
      || "Не удалось обновить название вакансии";

    window.alert(
      message
    );
  }
}

async function publishDraft(
  draft
) {

  if (
    !draft?.id
  ) {

    console.error(
      "❌ У VacancyDraft отсутствует id",
      draft
    );

    return;

  }


  if (
    publishingDraftId.value
      === draft.id
  ) {

    return;

  }


  try {

    publishingDraftId.value =
      draft.id;


    console.log(
      "🚀 Публикуем VacancyDraft:",
      draft.id
    );


    const result =
      await AdminService
        .publishAdminVacancyDraft(
          draft.id
        );


    console.log(
      "✅ VacancyDraft опубликован:",
      result
    );


    // ======================================================
    // УДАЛЯЕМ ИЗ СПИСКА
    // ======================================================

    drafts.value =
      drafts.value.filter(
        item =>
          item.id
            !== draft.id
      );


    // ======================================================
    // ПЕРЕСЧИТЫВАЕМ СТАТИСТИКУ
    // ======================================================

    recalculateCounts();


    // ======================================================
    // POPUP
    // ======================================================

    showPublishedPopup(
      result?.message
      || "Вакансия успешно опубликована"
    );


  } catch (error) {

    console.error(
      "❌ Ошибка публикации VacancyDraft:",
      error.response?.data
      || error.message
    );


    const message =
      error?.response
        ?.data
        ?.error
      || error?.message
      || "Не удалось опубликовать вакансию";


    publishPopupMessage.value =
      message;

    showPublishPopup.value =
      true;


    if (
      publishPopupTimer
    ) {

      clearTimeout(
        publishPopupTimer
      );

    }


    publishPopupTimer =
      window.setTimeout(
        () => {

          showPublishPopup.value =
            false;

          publishPopupTimer =
            null;

        },
        4000
      );


  } finally {

    publishingDraftId.value =
      null;

  }

}

async function updateDraftDescription({
  draft,
  description
}) {
  if (!draft?.id) {
    console.error(
      "❌ У VacancyDraft отсутствует id",
      draft
    );

    return;
  }

  const normalizedDescription =
    String(description || "").trim();

  if (!normalizedDescription) {
    window.alert(
      "Описание вакансии не может быть пустым"
    );

    return;
  }

  try {
    console.log(
      "📝 Обновляем description VacancyDraft:",
      draft.id
    );

    const result = await AdminService
      .updateAdminVacancyDraftDescription(
        draft.id,
        normalizedDescription
      );

    console.log(
      "✅ Description VacancyDraft обновлён:",
      result
    );

    draft.description =
      normalizedDescription;

    if (
      draft.vacancy
      && typeof draft.vacancy === "object"
    ) {
      draft.vacancy.description =
        normalizedDescription;
    }

    // Форсим обновление массива.
    drafts.value = [
      ...drafts.value
    ];

    console.log(
      "✅ Локальный description обновлён"
    );
  } catch (error) {
    console.error(
      "❌ Ошибка обновления description VacancyDraft:",
      error.response?.data
      || error.message
    );

    const message =
      error?.response?.data?.error
      || error?.message
      || "Не удалось обновить описание вакансии";

    window.alert(
      message
    );
  }
}

async function runVacancyPipeline() {

if (
  isPipelineRunning.value
) {
  return;
}

isPipelineRunning.value =
  true;

showPipelineOverlay.value =
  true;

pipelineOverlayStatus.value =
  "running";

pipelineResult.value =
  null;

pipelineErrorMessage.value =
  "";

try {

  console.log(
    "🚀 Запускаем pipeline VacancyDrafts"
  );

  const result =
    await AdminService
      .runPipelineVacancyDrafts({
        limit: 200,
        retryCompanies: true,
        retryImages: true
      });

  console.log(
    "✅ Pipeline VacancyDrafts завершён:",
    result
  );

  pipelineResult.value =
    result;

  pipelineOverlayStatus.value =
    "success";

  // После обработки сразу подтягиваем
  // актуальные VacancyDrafts.
  await loadDrafts();

} catch (error) {

  console.error(
    "❌ Pipeline VacancyDrafts error:",
    error.response?.data
    || error.message
  );

  pipelineErrorMessage.value =
    error?.response?.data?.error
    || error?.message
    || "Не удалось выполнить обработку вакансий";

  pipelineOverlayStatus.value =
    "error";

} finally {

  isPipelineRunning.value =
    false;

}
}


function closePipelineOverlay() {

if (
  isPipelineRunning.value
) {
  return;
}

showPipelineOverlay.value =
  false;

}

async function deleteDraft(draft) {
  if (!draft?.id) {
    console.error(
      "❌ У VacancyDraft отсутствует id",
      draft
    );

    return;
  }

  if (deletingDraftId.value === draft.id) {
    return;
  }

  try {
    deletingDraftId.value = draft.id;

    console.log(
      "🗑 Удаляем VacancyDraft:",
      draft.id
    );

    const result = await AdminService
      .deleteAdminPendingVacancyDraft(
        draft.id
      );

    console.log(
      "✅ VacancyDraft удалён:",
      result
    );

    drafts.value = drafts.value.filter(
      item => item.id !== draft.id
    );

    recalculateCounts();
  } catch (error) {
    console.error(
      "❌ Ошибка удаления VacancyDraft:",
      error.response?.data
      || error.message
    );

    const message =
      error?.response?.data?.error
      || error?.message
      || "Не удалось удалить черновик";

    window.alert(message);
  } finally {
    deletingDraftId.value = null;
  }
}

function showPublishedPopup(
  message
) {

  publishPopupMessage.value =
    message;

  showPublishPopup.value =
    true;

  if (
    publishPopupTimer
  ) {

    clearTimeout(
      publishPopupTimer
    );

  }

  publishPopupTimer =
    window.setTimeout(
      () => {

        showPublishPopup.value =
          false;

        publishPopupTimer =
          null;

      },
      3500
    );

}
  
  function openCreateCompanyDrawer(
  draft
) {

  selectedDraftForCompany.value =
    draft;

  showCompanyDrawer.value =
    true;

}


function closeCreateCompanyDrawer() {

  showCompanyDrawer.value =
    false;

  selectedDraftForCompany.value =
    null;

}


function handleCompanyCreated(
  message
) {

  console.log(
    "✅ Компания создана из VacancyDraft:",
    {
      draft:
        selectedDraftForCompany.value,

      message
    }
  );

}
  
  function getCurrentThemeClass() {
  
    const theme =
      document
        .documentElement
        .getAttribute(
          "data-theme"
        );
  
    return (
      theme === "light"
        ? "theme-light"
        : "theme-dark"
    );
  
  }
  
  
  function setupThemeObserver() {
  
    themeObserver =
      new MutationObserver(
        () => {
  
          themeClass.value =
            getCurrentThemeClass();
  
        }
      );
  
    themeObserver.observe(
      document.documentElement,
      {
        attributes:
          true,
  
        attributeFilter: [
          "data-theme"
        ]
      }
    );
  
  }
  
  
  onMounted(
  async () => {

    try {

      /*
       * Ждём восстановления Firebase-сессии.
       */
      const user =
        await waitForAuthReady();


      /*
       * Пользователь вообще не авторизован.
       */
      if (!user) {

        console.warn(
          "❌ VacancyDrafts: пользователь не авторизован"
        );

        window.location.replace(
          "https://hr3.space/"
        );

        return;
      }


      /*
       * Проверяем локальный admin flag.
       */
      const adminFlag =
        localStorage.getItem(
          "is_admin"
        ) === "true";


      if (!adminFlag) {

        console.warn(
          "⛔ VacancyDrafts: пользователь не является администратором"
        );

        window.location.replace(
          "https://hr3.space/"
        );

        return;
      }


      /*
       * Только теперь разрешаем UI.
       */
      isAdmin.value =
        true;


      /*
       * И только после проверки
       * запускаем остальную логику страницы.
       */
      setupThemeObserver();

      await loadDrafts();


    } catch (error) {

      console.error(
        "❌ Ошибка проверки доступа VacancyDrafts:",
        error
      );

      window.location.replace(
        "https://hr3.space/"
      );


    } finally {

      isAccessChecked.value =
        true;

    }

  }
);
  
  
  onBeforeUnmount(
    () => {

      if (
        themeObserver
      ) {

        themeObserver.disconnect();

        themeObserver =
          null;

      }


      if (
        publishPopupTimer
      ) {

        clearTimeout(
          publishPopupTimer
        );

        publishPopupTimer =
          null;

      }

    }
  );
  
  </script>
  
  <style scoped>
  
  .admin-vacancy-drafts {
    --vd-bg: #111111;
    --vd-card: #181818;
    --vd-soft: #202020;
    --vd-image-bg: #202020;
  
    --vd-text: #f4f4f4;
    --vd-secondary: #b5b5b5;
    --vd-muted: #767676;
  
    --vd-border: #292929;
    --vd-border-hover: #3a3a3a;
  
    min-height: 100%;
    padding: 34px 34px 70px;
    background: var(--vd-bg);
    color: var(--vd-text);
  }
  
  .admin-vacancy-drafts.theme-light {
    --vd-bg: #f7f7f8;
    --vd-card: #ffffff;
    --vd-soft: #f3f3f4;
    --vd-image-bg: #eeeeef;
  
    --vd-text: #171717;
    --vd-secondary: #555555;
    --vd-muted: #8a8a8a;
  
    --vd-border: #e6e6e7;
    --vd-border-hover: #ccccce;
  }
  
  .page-header {
    display: flex;
    max-width: 1180px;
    margin: 0 auto;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
  }
  
  .page-eyebrow {
    margin: 0 0 8px;
    color: var(--vd-muted);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
  }
  
  .page-title {
    margin: 0;
    color: var(--vd-text);
    font-size: 28px;
    font-weight: 680;
    letter-spacing: -0.03em;
  }
  
  .page-description {
    margin: 8px 0 0;
    color: var(--vd-muted);
    font-size: 12px;
  }
  
  .refresh-button {
    display: inline-flex;
    height: 38px;
    padding: 0 13px;
    align-items: center;
    gap: 7px;
    border: 1px solid var(--vd-border);
    border-radius: 10px;
    background: var(--vd-card);
    color: var(--vd-text);
    cursor: pointer;
    font-size: 11px;
  }
  
  .refresh-button:disabled {
    cursor: default;
    opacity: 0.5;
  }
  
  .refresh-icon {
    font-size: 17px;
  }
  
  .refresh-icon.rotating {
    animation: rotate 0.8s linear infinite;
  }
  
  .stats-grid {
    display: grid;
    max-width: 1180px;
    margin: 26px auto 0;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }
  
  .stat-card {
    display: flex;
    min-height: 84px;
    padding: 14px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    border: 1px solid var(--vd-border);
    border-radius: 13px;
    background: var(--vd-card);
    color: inherit;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s ease;
  }
  
  .stat-card:hover,
  .stat-card.active {
    border-color: var(--vd-border-hover);
  }
  
  .stat-card.active {
    box-shadow:
      inset 0 0 0 1px
      var(--vd-border-hover);
  }
  
  .stat-label {
    color: var(--vd-muted);
    font-size: 10px;
  }
  
  .stat-value {
    font-size: 24px;
    font-weight: 650;
  }
  
  .stat-value.success {
    color: #26945b;
  }
  
  .stat-value.warning {
    color: #bd8129;
  }
  
  .toolbar {
    display: flex;
    max-width: 1180px;
    margin: 18px auto 0;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
  }
  
  .search-wrapper {
    display: flex;
    width: min(380px, 100%);
    height: 40px;
    padding: 0 12px;
    align-items: center;
    gap: 8px;
    border: 1px solid var(--vd-border);
    border-radius: 10px;
    background: var(--vd-card);
  }
  
  .search-wrapper svg {
    width: 16px;
    height: 16px;
    color: var(--vd-muted);
  }
  
  .search-input {
    width: 100%;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: var(--vd-text);
    font: inherit;
    font-size: 11px;
  }
  
  .search-input::placeholder {
    color: var(--vd-muted);
  }
  
  .filter-tabs {
    display: flex;
    padding: 3px;
    border: 1px solid var(--vd-border);
    border-radius: 10px;
    background: var(--vd-card);
    gap: 2px;
  }
  
  .filter-tab {
    padding: 7px 10px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: var(--vd-muted);
    cursor: pointer;
    font-size: 10px;
  }
  
  .filter-tab.active {
    background: var(--vd-soft);
    color: var(--vd-text);
  }
  
  .results-row {
    display: flex;
    max-width: 1180px;
    margin: 18px auto 8px;
    color: var(--vd-muted);
    font-size: 10px;
  }
  
  .draft-list,
  .loading-list {
    display: flex;
    max-width: 1180px;
    margin: 0 auto;
    flex-direction: column;
    gap: 12px;
  }
  
  .state-card {
    display: flex;
    max-width: 1180px;
    margin: 40px auto 0;
    padding: 60px 24px;
    flex-direction: column;
    align-items: center;
    border: 1px solid var(--vd-border);
    border-radius: 16px;
    background: var(--vd-card);
    text-align: center;
  }
  
  .state-card h3 {
    margin: 12px 0 6px;
    font-size: 15px;
  }
  
  .state-card p {
    margin: 0;
    color: var(--vd-muted);
    font-size: 11px;
  }
  
  .state-icon {
    display: flex;
    width: 34px;
    height: 34px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--vd-soft);
    color: var(--vd-muted);
  }
  
  .state-button {
    margin-top: 18px;
    padding: 8px 13px;
    border: 1px solid var(--vd-border);
    border-radius: 8px;
    background: var(--vd-soft);
    color: var(--vd-text);
    cursor: pointer;
  }
  
  .draft-skeleton {
    display: grid;
    min-height: 220px;
    overflow: hidden;
    grid-template-columns: 210px 1fr;
    border: 1px solid var(--vd-border);
    border-radius: 18px;
    background: var(--vd-card);
  }
  
  .skeleton-image,
  .skeleton-line {
    background: var(--vd-soft);
    animation: pulse 1.2s ease-in-out infinite;
  }
  
  .skeleton-content {
    padding: 22px;
  }
  
  .skeleton-line {
    width: 75%;
    height: 11px;
    margin-bottom: 13px;
    border-radius: 5px;
  }
  
  .skeleton-line.small {
    width: 80px;
    height: 9px;
  }
  
  .skeleton-line.title {
    width: 48%;
    height: 22px;
  }
  
  .skeleton-line.short {
    width: 36%;
  }
  
  @keyframes pulse {
  
    0%,
    100% {
      opacity: 0.55;
    }
  
    50% {
      opacity: 1;
    }
  
  }
  
  @keyframes rotate {
  
    from {
      transform: rotate(0);
    }
  
    to {
      transform: rotate(360deg);
    }
  
  }
  
  @media (max-width: 900px) {
  
    .stats-grid {
      grid-template-columns:
        repeat(2, minmax(0, 1fr));
    }
  
    .toolbar {
      align-items: stretch;
      flex-direction: column;
    }
  
    .search-wrapper {
      width: 100%;
    }
  
    .filter-tabs {
      overflow-x: auto;
    }
  
  }
  
  @media (max-width: 760px) {
  
    .admin-vacancy-drafts {
      padding:
        24px 16px
        60px;
    }
  
    .draft-skeleton {
      grid-template-columns: 1fr;
    }
  
    .skeleton-image {
      min-height: 180px;
    }
  
  }
  
  @media (max-width: 520px) {
  
    .page-header {
      flex-direction: column;
    }
  
    .stats-grid {
      grid-template-columns: 1fr 1fr;
    }
  
    .page-title {
      font-size: 24px;
    }
  
  }

  /* =========================================================
   PUBLISH POPUP
========================================================= */

.publish-popup {
  position: fixed;

  right: 28px;
  bottom: 28px;

  z-index: 10000;

  min-width: 300px;
  max-width: 420px;

  display: flex;
  align-items: center;

  gap: 12px;

  padding:
    14px
    16px;

  color: var(--vd-text);

  background:
    var(--vd-card);

  border:
    1px solid
    var(--vd-border);

  border-radius: 14px;

  box-shadow:
    0 16px 44px
    rgba(
      0,
      0,
      0,
      0.16
    );
}


.publish-popup-icon {
  width: 36px;
  height: 36px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #28aa65,
      #218d55
    );

  border-radius: 11px;

  box-shadow:
    0 6px 14px
    rgba(
      33,
      141,
      85,
      0.22
    );
}


.publish-popup-icon svg {
  width: 18px;
  height: 18px;
}


.publish-popup-content {
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: 3px;
}


.publish-popup-content strong {
  color:
    var(--vd-text);

  font-size: 12px;
  font-weight: 650;
}


.publish-popup-content span {
  color:
    var(--vd-muted);

  font-size: 10px;
  line-height: 1.4;
}


/* =========================================================
   TRANSITION
========================================================= */

.publish-popup-enter-active,
.publish-popup-leave-active {
  transition:
    opacity 0.22s ease,
    transform 0.25s ease;
}


.publish-popup-enter-from,
.publish-popup-leave-to {
  opacity: 0;

  transform:
    translateY(12px);
}


@media (
  max-width: 600px
) {

  .publish-popup {
    right: 14px;
    bottom: 14px;
    left: 14px;

    min-width: 0;
    max-width: none;
  }

}

.page-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}


.pipeline-button {
  position: relative;

  display: inline-flex;
  height: 38px;

  padding:
    0
    14px;

  align-items: center;
  justify-content: center;

  gap: 8px;

  overflow: hidden;

  border: 0;
  border-radius: 10px;

  background:
    linear-gradient(
      135deg,
      #5575f6,
      #7657eb
    );

  color: #ffffff;

  cursor: pointer;

  font-size: 11px;
  font-weight: 600;

  box-shadow:
    0 7px 18px
    rgba(
      91,
      92,
      230,
      0.18
    );

  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    opacity 0.18s ease;
}


.pipeline-button::before {
  content: "";

  position: absolute;

  top: 0;
  bottom: 0;

  left: -70%;

  width: 45%;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(
        255,
        255,
        255,
        0.18
      ),
      transparent
    );

  transform: skewX(-18deg);

  transition:
    left 0.45s ease;
}


.pipeline-button:hover:not(:disabled) {
  transform:
    translateY(-1px);

  box-shadow:
    0 10px 24px
    rgba(
      91,
      92,
      230,
      0.26
    );
}


.pipeline-button:hover:not(:disabled)::before {
  left: 130%;
}


.pipeline-button:active:not(:disabled) {
  transform:
    translateY(0);
}


.pipeline-button:disabled {
  cursor: default;
  opacity: 0.55;
}


.pipeline-button-icon {
  position: relative;

  display: flex;

  width: 16px;
  height: 16px;

  align-items: center;
  justify-content: center;
}


.pipeline-button-icon svg {
  width: 16px;
  height: 16px;
}


.pipeline-button:disabled
.pipeline-button-icon {
  animation:
    pipeline-button-pulse
    1.4s
    ease-in-out
    infinite;
}


@keyframes pipeline-button-pulse {

  0%,
  100% {
    opacity: 0.65;
    transform: scale(0.94);
  }

  50% {
    opacity: 1;
    transform: scale(1.06);
  }

}

@media (max-width: 520px) {

.page-header-actions {
  width: 100%;
}

.pipeline-button {
  flex: 1;
}

}
  
  </style>